import React from "react";
import { Check } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const tiers = [{
  name: "Let Only",
  description: "Perfect for experienced landlords who manage their own maintenance.",
  features: ["Market appraisal & valuation", "Professional photography", "Marketing on major portals", "Accompanied viewings", "Tenant referencing", "Tenancy agreement preparation", "First month's rent collection"],
  cta: "Inquire Now",
  popular: false
}, {
  name: "Fully Managed",
  description: "Our most comprehensive service for complete peace of mind.",
  features: ["All Let Only & Rent Collection features", "Dedicated property manager", "Maintenance coordination", "24/7 emergency support", "Routine property inspections", "Deposit protection registration", "Legal compliance updates", "End of tenancy management"],
  cta: "Inquire Now",
  popular: true
}, {
  name: "Rent Collection",
  description: "We handle the financials while you handle the property.",
  features: ["All Let Only features", "Monthly rent collection", "Arrears chasing & management", "Monthly financial statements", "Annual tax statements", "Tenancy renewal negotiation", "Rent increase negotiation"],
  cta: "Inquire Now",
  popular: false
}];
export default function ManagementSolutions() {
  return <section id="management-solutions" className="bg-background py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-medium text-foreground mb-6">
            Tailored Management Solutions
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Choose the level of service that suits your lifestyle. From finding the perfect tenant to full property management, we have you covered.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          {tiers.map((tier, i) => <div key={tier.name} data-index={i} className={`relative transition-all duration-300 ${tier.popular ? "lg:-mt-4 lg:mb-0 z-10 shadow-2xl" : "shadow-lg hover:shadow-xl"}`}>
              <Card className={`h-full flex flex-col border-border bg-card ${tier.popular ? "border-primary/20 ring-1 ring-primary/10" : ""}`}>
                <CardHeader className="pb-8">
                  {tier.popular && <div className="absolute top-0 right-0 -mt-3 mr-4">
                      <Badge className="bg-accent text-accent-foreground hover:bg-accent/90 px-3 py-1 text-sm font-semibold uppercase tracking-wide shadow-sm">
                        Popular
                      </Badge>
                    </div>}
                  <CardTitle className="text-2xl font-serif font-medium text-card-foreground">
                    {tier.name}
                  </CardTitle>
                  <CardDescription className="text-muted-foreground mt-2 text-base">
                    {tier.description}
                  </CardDescription>
                </CardHeader>
                <CardContent className="flex-grow">
                  <ul className="space-y-4">
                    {tier.features.map((feature, index) => <li key={index} className="flex items-start gap-3">
                        <div className="mt-1 shrink-0 rounded-full bg-primary/10 p-1">
                          <Check className="h-3.5 w-3.5 text-primary" />
                        </div>
                        <span className="text-sm text-card-foreground/80 font-sans">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                </CardContent>
                <CardFooter className="pt-8">
                  <Button asChild className={`w-full font-sans uppercase tracking-wider ${tier.popular ? "bg-primary text-primary-foreground hover:bg-primary/90" : "bg-secondary text-secondary-foreground hover:bg-secondary/90"}`} size="lg">
                    <Link to="/ContactPage">{tier.cta}</Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}